// Pevný katalog vestavěných lekcí. Sdílený mezi uživatelským menu (LessonMenu),
// admin záložkou pro schovávání lekcí (LessonVisibilityManager) a nabídkou
// cvičení (ExerciseMenu), aby existoval jen jeden zdroj pravdy o tom, jaké
// lekce a v jakém pořadí jsou.
//
// Témata a jejich pořadí odpovídají zadání ASEN (slovník pro 10 lekcí, úroveň
// A2). Obsah lekcí na backendu žije v `app/core/seeds/a2/` a klíč `topic` je
// to jediné, co obě strany spojuje — musí sedět přesně.
export const BUILT_IN_LESSONS = [
  { id: 1, topic: 'family_hobbies', title: 'Rodina a koníčky',
    description: 'Umím mluvit o své rodině, o koníčcích a o tom, co kdo umí', image: '/images/family.jpg' },
  { id: 2, topic: 'shopping_cafe', title: 'Nákupy, kavárna a jídlo',
    description: 'Umím nakoupit, objednat si v kavárně a zaplatit', image: '/images/cafe.jpg' },
  { id: 3, topic: 'weather_health', title: 'Počasí a zdraví',
    description: 'Umím popsat počasí, říct, co mě bolí, a dát jednoduchou radu', image: '/images/weather.jpg' },
  { id: 4, topic: 'work_internet', title: 'Práce a internet',
    description: 'Umím mluvit o práci a poradit si s účtem, heslem a e-mailem', image: '/images/work.jpg' },
  { id: 5, topic: 'travel', title: 'Cestování',
    description: 'Umím vyprávět o cestě, dovolené a poradit si na nádraží i na letišti', image: '/images/travel.jpg' },
  { id: 6, topic: 'city_transport', title: 'Město a doprava',
    description: 'Umím popsat své město, zeptat se na cestu a jet městskou dopravou', image: '/images/city_transport.jpg' },
  { id: 7, topic: 'news_gossip', title: 'Novinky a klepy',
    description: 'Umím mluvit o zprávách, o tom, co jsem slyšel/a, a oddělit fakt od fámy', image: '/images/news_gossip.jpg' },
  { id: 8, topic: 'people_places', title: 'Lidé a místa',
    description: 'Umím popsat lidi a místa kolem sebe a provést někoho po městě', image: '/images/people_places.jpg' },
  { id: 9, topic: 'old_and_new', title: 'Staré časy vs. moderní svět',
    description: 'Umím porovnat dřívější život s dnešním a mluvit o technice', image: '/images/past_events.jpg' },
  { id: 10, topic: 'dreams_goals', title: 'Sny a cíle',
    description: 'Umím mluvit o svých plánech, přáních a cílech do budoucna', image: '/images/dreams_goals.jpg' },
];

// Název lekce podle klíče tématu. Dřív existovala druhá, ručně udržovaná kopie
// v ExerciseMenu.js; odvozením se nemůžou rozejít.
export const TOPIC_TITLES = Object.fromEntries(
  BUILT_IN_LESSONS.map((lesson) => [lesson.topic, lesson.title])
);
